module.exports = __webpack_public_path__ + "static/img/page1-bc.44abc51d.png";